import constants from '../constants.js';

const AcceptedSuppliersSupplierCode = {
  displayName: 'Supplier Code',
  dataAt: 'AcceptedSuppliers.$railCardSup.SupplierCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const AcceptedSuppliersSupplier = {
  displayName: 'Supplier',
  dataAt: 'AcceptedSuppliers.$railCardSup.Supplier',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const AcceptedSuppliersItem = {
  displayName: 'Accepted Suppliers',
  dataAt: 'AcceptedSuppliers.$railCardSup',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [AcceptedSuppliersSupplier, AcceptedSuppliersSupplierCode],
  endpoint: 'RailCards',
  routeParamId: 'railCardId',
  removeParamId: 'railCardSup',
  canDelete: true
};

const AcceptedSuppliers = {
  displayName: 'Accepted Suppliers',
  dataAt: 'AcceptedSuppliers',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: AcceptedSuppliersItem,
  gridCols:
    [{name: 'Supplier', key: 'Supplier'},
      {name: 'Supplier Code', key: 'SupplierCode'}]
};

const InternalCode = {
  displayName: 'Internal Code',
  dataAt: 'InternalCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const IssuerCode = {
  displayName: 'Issuer Code',
  dataAt: 'IssuerCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const OriginAcceptingCountryCode = {
  displayName: 'Origin Accepting Country Code',
  dataAt: 'OriginAcceptingCountryCode',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const RailCardsHomeCountryCode = {
  displayName: 'Home Country Code',
  dataAt: 'HomeCountryCode',
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT,
  selectType: 'single'
};

const InternalName = {
  displayName: 'Internal Name',
  dataAt: 'InternalName',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const RailCardLocalName = {
  displayName: 'Rail Card Local Name',
  dataAt: 'RailCardLocalName',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const RailCardsAddResource = {
  displayAs: constants.DISPLAY_AS.ADD_GRID_RESOURCE,
  displayName: 'Rail Cards',
  data:
    {
      RailCardLocalName: '',
      InternalName: '',
      HomeCountryCode: '',
      OriginAcceptingCountryCode: [],
      IssuerCode: '',
      InternalCode: '',
      AcceptedSuppliers: []
    },
  dataAt: '',
  children: [RailCardLocalName, InternalName, RailCardsHomeCountryCode, OriginAcceptingCountryCode, IssuerCode, InternalCode],
  endpoint: 'RailCards'
};

const RailCardsResource = {
  displayName: 'Rail Cards',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  dataAt: '',
  children: [RailCardLocalName, InternalName, RailCardsHomeCountryCode, OriginAcceptingCountryCode, IssuerCode, InternalCode, AcceptedSuppliers],
  endpoint: 'RailCards',
  routeParamId: 'railCardId'
};

const RailCardsList = {
  rootNode: true,
  displayName: 'Rail Cards',
  endpoint: 'RailCards',
  iconClass: 'fa-train',
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GRID,
  gridItem: RailCardsResource,
  gridAdd: RailCardsAddResource,
  gridCols:
    [{name: 'Name', key: 'RailCardLocalName'},
      {name: 'Internal Name', key: 'InternalName'}]
};

export default {
  RailCardsList,
  RailCardsResource,
  RailCardsAddResource,
  RailCardLocalName,
  InternalName,
  RailCardsHomeCountryCode,
  OriginAcceptingCountryCode,
  IssuerCode,
  InternalCode,
  AcceptedSuppliers,
  AcceptedSuppliersItem,
  AcceptedSuppliersSupplier,
  AcceptedSuppliersSupplierCode
}



// WEBPACK FOOTER //
// ./src/config/fields/railCards.js